















































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {store} from "@/_store";
import {SNACK_ACTION} from "@/_store/snackbar";
import {IMediaViewModel} from "@/_objects/IMedia";
import {update, updateApproveWithComments} from "@/_services/media.services";

@Component({
    components: {},
})
export default class MediaEdit extends Vue {
    @Prop() private media!: IMediaViewModel;
    @Prop({default: false}) private show!: string;
    private loading: boolean = false;
    private fileName: string = "";
    private file?: {
        base64: string;
        ext: string;
        type: string;
    };
    get isApproveMode() {
        return !this.media.isApproved;
    }

    private close() {
        this.$emit('update:show', false);
    }

    private async save() {
        this.loading = true;
        try {
            const newCreative = await update(this.media.id, {
                id: this.media.id,
                subid: this.media.subid,
                subid2: this.media.subid2,
                description: this.media.description,
                comment: this.media.comment,
                url: this.media.url,
                file: this.file,
                blockZovio: this.media.blockZovio,
                blockPEC: this.media.blockPEC,
                brandingBEM:  this.media.brandingBEM,
                brandingPub:  this.media.brandingPub,
                pell38K:  this.media.pell38K,
                pell6K:  this.media.pell6K,
                pellYear:  this.media.pellYear,
                type:  this.media.type,
            });
            if (newCreative) {
                store.dispatch(SNACK_ACTION.SUCCESS, `<b>Creative updated successfully.`);
                this.$emit('update:show', false);
                this.$emit('success', true);
            }
        } catch (err) {
            // Do nothing

        }
        this.loading = false;
    }

    private pickFile() {
        (this.$refs.uploadInput as any).click();
    }

    private onFilePicked(e: any) {
        const file = e.target.files[0];

        if (!file) {
            this.file = undefined;
            return;
        }
        this.fileName = file.name;
        this.getBase64(file);
    }

    private getBase64(file: File) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.file = {
                base64: reader.result as string,
                ext: '.' + file.name.split('.').pop(),
                type: file.type,
            };
            this.file.ext = this.file.ext.toLowerCase();
        };
    }

    @Watch('media')
    private onMediaChanged() {
        (this.$refs.form as any).resetValidation();
        this.media.url = "";
        this.fileName = "";
    }

}
